<template>
  <div class="gui-flex gui-flex-rows">
    <div class="mb-3 no__radius">
      <v-data-table
        :headers="headers"
        :items="items"
        hide-controls
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.datum | formatSimpleDate }}</td>
          <td>{{ props.item.castka | formatMoney }} Kč</td>
          <td>{{ props.item.variabilni_symbol }}</td>
          <td>{{ props.item.bank_identifikace }}</td>
          <td>{{ props.item.protiucet }}<span v-if="props.item.protiucet != null && props.item.protiucet.length > 0 && props.item.protiucet_kod != null && props.item.protiucet_kod.length > 0"></span>{{ props.item.protiucet_kod }}</td>
          <td>{{ props.item.bank_nazev_uctu }}</td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Částka', value: 'castka' },
        { text: 'Variabilní symbol', value: 'variabilni_symbol' },
        { text: 'Bankovní identifikace', value: 'bank_identifikace' },
        { text: 'Protiúčet', value: 'protiucet' },
        { text: 'Název protiúčtu', value: 'bank_nazev_uctu' }
      ],
      items: [

      ]
    }
  },
  props: {
    id: String,
    program: String
  },
  mounted: function() {
    window.API.get("osoby/"+this.$props.id+"/sporici-programy/"+this.$props.program+"/platby-ucet").then(function(body) {
      this.items = body;
    }.bind(this)).catch(function(err) {
      console.log(err);
    }.bind(this));
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/PlatbyUcet.vue